import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e9f18b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "remove-task-modal__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "remove-task-modal__ul" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Тикет связан с другой задачей/очередью"),
  /*#__PURE__*/_createElementVNode("li", null, "Уже запускался таймер на выполнение")
], -1))
const _hoisted_3 = ["textContent"]

import { TirPmButton, TirPmModal, TirPmButtonVariantEnum } from "tir-components";
import { useLoading, useModal } from "tir-pm-toolkit";
import { computed, PropType, ref } from "vue";
import { AdapterService } from "./adapter-service";
import { TimeTrackerRecordModel } from "../task-forms";

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'remove-task-modal',
  props: {
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**переносится ли задача */
  transferTask: {
    type: Boolean,
    default: false,
  },
},
  emits: ["successRemove"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const apiService = new AdapterService();

/**пропсы */


/**События */


/**Id задачи */
const taskId = ref<number>();
/**Имя задачи */
const taskName = ref<string>();
/**Произошла ошибка при удалении */
const removeError = ref(false);
/**Управление окном */
const { visible, open, close } = useModal();
/**Управление загрузкой */
const { isLoading, startLoading, stopLoading } = useLoading();

/**Заголовок окна */
const modalTitle = computed(() =>
  removeError.value ? "Невозможно удалить тикет" : "Удалить тикет",
);

/**Удалить задачу */
const removeTask = async () => {
  startLoading();

  const id = taskId.value;
  const name = taskName.value;

  if (!props.timerTrackerRecords.length || props.transferTask) {
    const response = await apiService.RemoveTask(id, name);

    if (response.IsSuccess && response.Value) {
      emit("successRemove", id);
      closeModal();
    }
  } else {
    setTimeout(() => (removeError.value = true));
  }

  stopLoading();
};
/**Открыть окно */
const openModal = (id: number, name: string) => {
  removeError.value = false;

  if (!id) return;

  taskId.value = id;
  taskName.value = name;
  open();
};
/**Закрыть окно */
const closeModal = () => {
  close();
  removeError.value = false;
  taskId.value = undefined;
  taskName.value = undefined;
  stopLoading();
};

/**Код для использования по ref */
__expose({ open: openModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    title: modalTitle.value,
    "is-visible": _unref(visible),
    isWithBack: false,
    isCloseOverlay: true,
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (removeError.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Одна из возможных причин: "),
              _hoisted_2
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Вы уверены что хотите удалить тикет: "),
              (taskName.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "remove-task-modal__task-name",
                    textContent: _toDisplayString(taskName.value)
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              _createTextVNode("? ")
            ], 64))
      ])
    ]),
    footer: _withCtx(() => [
      (removeError.value)
        ? (_openBlock(), _createBlock(_unref(TirPmButton), {
            key: 0,
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            onClick: closeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Понятно ")
            ]),
            _: 1
          }, 8, ["variant"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(TirPmButton), {
              "is-loading": _unref(isLoading),
              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
              onClick: removeTask
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Удалить ")
              ]),
              _: 1
            }, 8, ["is-loading", "variant"]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["variant"])
          ], 64))
    ]),
    _: 1
  }, 8, ["title", "is-visible"]))
}
}

})